<div class="data-area-content">
    <div class="data-area" id="dataArea" [attr.data-automation-id]="automationId + '-data-area-container'">
        <res-generic-grid gridName="Data Areas" [automationId]="automationId" [columnDefs]="columnDefs"
            [rowSelection]="rowSelection" [requestInfo]="requestInfo"
            [loadDataFinishedCallback]="loadDataFinishedCallback" [responseArrayCallback]="responseArrayCallback"
            [onSelectionChanged]="onSelectionChanged" [isRefreshIconHidden]="true">
        </res-generic-grid>
    </div>

    <res-resizer [attr.data-automation-id]="automationId + '-resizer-button'" anchor="left" resizingElementId="dataArea"
        secondElementId="dataAreaPath" [usePercentages]="true" [initSize]="40" [minSize]="20" [maxSize]="80"
        [ellipsisExpander]="true"></res-resizer>

    <div class="modal-fill data-area-path" id="dataAreaPath"
        [attr.data-automation-id]="automationId + '-path-container'" [resBusySpinner]="isPathsBusy"
        message="Loading Paths ...">
        <div class="header header-cell">
            <span requiredAsterisk>{{pathHeader}}
            </span>
        </div>
        <div class="tree-container">
            <div class="place-holder-area">
                <div *ngIf="!selectedDataArea" class="hint-popover">
                    <i class="fa fa-arrow-left"></i>Please select a Data Area
                </div>
            </div>
            <div class="tree-content" *ngIf="selectedDataArea">
                <res-generic-tree [automationId]="automationId + '-tree'" [loadNodeDataCallback]="loadNodeDataCallback"
                    [selectedNodeChangedCallback]="selectedNodeChangedCallback">
                </res-generic-tree>
            </div>
        </div>
    </div>
</div>